"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixOverline = fixOverline;
const tex_syntax_1 = require("./tex-syntax");
const overlineWithMissingBraces = new RegExp(`(\\\\overline)(\\\\(?:text|${tex_syntax_1.color})${(0, tex_syntax_1.arg)(1)})`, "g");
function fixOverline(tex) {
    return tex.replace(overlineWithMissingBraces, "$1{$2}");
}
